<template>
    <div class="upload">
        <el-upload
            name="file"
            ref="uploadDom"
            class="avatar-uploader"
            :action="uploadData.action"
            :headers="uploadData.headers"
            :multiple="uploadData.multiple"
            :data="uploadData.data"
            :show-file-list="uploadData.showFileList"
            :drag="uploadData.drag"
            :accept="uploadData.accept"
            :list-type="uploadData.listType"
            :auto-upload="uploadData.autoUpload"
            :disabled="uploadData.disabled"
            :file-list="uploadData.fileList"
            :limit="uploadData.limit"
            :on-preview="onPreview"
            :on-success="onSuccess"
            :on-error="onError"
            :on-remove="onRemove"
            :on-progress="onProgress"
            :on-change="fileChange"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            :on-exceed="handleExceed"
            >
            <template>
                <template v-if="uploadData.listType == 'text' || uploadData.listType == 'picture' ">
                    <div v-if="uploadData.uploadText == 'border'" class="el_upload-div">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </div>
                    <div v-if="uploadData.uploadText == 'buttom'">
                        <el-button icon="el-icon-upload" size="small" type="primary">{{uploadData.buttonText}}</el-button>
                    </div>
                </template>
                <template v-else>
                    <i slot="default" class="el-icon-plus"></i>
                </template>
                <slot v-if="$slots.trigger" name="upload"></slot>
                <!-- 自定义组件 -->
                <slot name="customize"></slot>
                <!-- 显示tip -->
                <div v-if="uploadData.showTip" slot="tip" class="el-upload__tip">
                    {{uploadData.tipText}}
                </div>
            </template>
        </el-upload> 
        <slot v-if="$slots.customist"></slot>
        <div v-if="!uploadData.showFileList && !$slots.customist">
            <ul class="uclass">
                <span>已上传文件列表</span>
                <li v-for="(items, indexs) in uploadList" :key="indexs" class="liclass">
                    <div>
                    {{ items.name }}
                    </div>
                    <el-button type="text" v-if="items.name.indexOf('.pdf')>=0 || items.name.indexOf('.txt')>=0
                    || items.name.indexOf('.txt')>=0
                    || items.name.indexOf('.png')>=0
                    || items.name.indexOf('.jpg')>=0
                    || items.name.indexOf('.jpeg')>=0" @click="filePreview((items.src || items.url),items.name.slice(items.name.lastIndexOf('.')+1))">预览</el-button>
                    <el-button class="download_file" type="text" @click="download((items.src || items.url))">下载</el-button>
                    <el-button type="text" class="remove_btn" style="margin-left: 10px" v-if="!uploadData.disabled" @click="customRemove(items.id)">删除</el-button>
                </li>
            </ul>
        </div>
        <!-- pdf -->
        <pdfView :pdfModel="pdfInfo.pdfModel" :pdfSrc="pdfInfo.pdfSrc" @closeModel="pdfInfo.pdfModel=false"/>
        <!-- txt -->
        <txtView :txtShow="txtInfo.txtShow" :txtContent="txtInfo.txtContent" @closeModel="txtInfo.txtShow=false"/>
        <!-- img -->
        <imgView :imgShow="imgInfo.imgShow" :imgSrc="imgInfo.imgSrc" @closeModel="imgInfo.imgShow=false"/>
    </div>
</template>

<script>
import imgView from '../../imgView'
import txtView from '../../txtView'
import pdfView from '../../pdfView'
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
export default {
    data(){
        return {
            uploadList:this.uploadData.fileList,
            //img
            imgInfo:{imgShow:false},
            txtInfo:{txtShow:false},
            pdfInfo:{pdfSrc:"",pdfModel:false}
        }
    },
    props:{
        uploadData:{
            require:true,
            default:()=>{
                return {

                }
            }
        },
    },
    watch:{
        'uploadData.fileList':{
            handler(newVal){
                console.log(newVal)
                this.uploadList = JSON.parse(JSON.stringify(newVal))
            },deep:true
        }
    },
    mounted(){
        console.log(this.uploadData)
    },
    components: {txtView,pdfView,imgView},
    methods:{
        //预览
        filePreview (val,type) {
            if(type == 'png' || type == 'jpg' || type == 'jpeg'){
                this.imgInfo = {
                    imgSrc:val,
                    imgShow:true
                }
            }else if(type == 'txt'){
                this.txtInfo = {
                    txtContent:val,
                    txtShow:true
                }
            }else{//pdf预览
                this.pdfInfo.pdfSrc = "";
                setTimeout(() => {
                    this.pdfInfo.pdfModel = true;
                    this.pdfInfo.pdfSrc = val;
                }, 200)
            }
        },
        //自定义删除附件
        customRemove (val) {
            this.uploadList = this.uploadList.filter(a=>a.id!=val);
            this.$emit('closePdfModel',this.uploadList)
            this.emitParent(this.uploadList);
        },
        //上传文件限制超出提示
        handleExceed() {
            this.$message.warning(`当前限制上传 ${this.uploadData.limit}个文件`);
        },
        //文件预览
        onPreview(){
            this.$emit('preview')
        },
        //文件上传成功
        onSuccess(response, file, fileList){
            this.uploadList.push({
                name: file.response.successFiles[0].name,
                type: file.response.successFiles[0].suffix,
                id: file.response.successFiles[0].id,
                src:
                    process.env.VUE_APP_BASE_API +
                    "/upload/download/?id=" +
                    file.response.successFiles[0].id,
            })
            this.$message.success('文件上传成功');
            this.$emit('responed',file)
            this.emitParent(this.uploadList);
        },
        //文件删除
        onRemove(file, fileList){
           let filter = fileList.filter(a=>{return file.id!=a.id})
           this.$emit('change',file, fileList)
           this.emitParent(filter);
        },
        //上传失败
        onError(err, file, fileList){
            this.$message.success(err);
            this.$emit('error', file, fileList)
        },
        //上传中
        onProgress(event, file, fileList){
            this.$emit('onProgress',event, file, fileList)
        },
        //文件状态改变调用
        fileChange(file, fileList){
            this.$emit('change',file, this.uploadList)
        },
        //触发父方法
        emitParent(fileList){
            this.$emit('fileList',fileList);

            this.$emit('fileListChange',fileList.map(a=>{
                return a.id
            }))
            this.$emit('fileUrl',fileList.map(a=>{
                return a.url
            }))
        },
        //上传之前
        beforeUpload(file){
            //文件上传大小限制
            let maxSize = "";
            if(this.uploadData.fileSize){
                switch(this.uploadData.sizeUnit){
                    case 'KB':maxSize = 1024*this.uploadData.fileSize;break;
                    case 'MB':maxSize = 1024*1024*this.uploadData.fileSize;break;
                    case 'GB':maxSize = 1024*1024*1024*this.uploadData.fileSize;break;
                }
                if(file.size > maxSize){
                    this.$message.warning(`最大只能上传${this.uploadData.fileSize}${this.uploadData.sizeUnit}`);
                    return false
                }
            }
            // 文件类型上传限制
            if(this.uploadData.fileType && !this.uploadData.fileType.split(",").includes(file.name.substring(file.name.lastIndexOf(".")+1))){
                this.$message.warning(`只能上传${this.uploadData.fileType}格式`);
                return false
            }
            this.$emit('beforeUpload',file);
        },
        //删除之前
        beforeRemove(file, fileList){
            this.$emit('beforeRemove',file, fileList);
        },
        //自定义上传
        httpRequests(file,reponse){
            console.log(file,reponse,11)
            // this.$emit('httpRequest',file)
        },
        //下载
        download(src){
            window.open(src)
        }
    }
}
</script>

<style lang="scss" scoped>
    .upload{
        .el_upload-div {
            border: 1px dashed #ccc;
            border-radius: 5px;
            padding: 10px;
            box-sizing: border-box;
            ::v-deep .el-icon-upload{
                font-size: 40px;
                color: #999;
            }
            ::v-deep .el-upload__text{
                font-size: 14px;
                em{
                    color: #409eff;
                    margin: 0 5px;
                }
            }
        }
        .uclass{
            list-style: none;
            padding-left: 0;
            .download_file{
                color: #409eff;
                cursor: pointer;
            }
            .remove_btn{
                color: #f08090;
            }
        }
    }
</style>